import React, { useEffect, useRef, useState } from "react";
import "../ItemApprove.css";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { ItemRequestFieldSearchAPI } from "../ItemApproveRequestAction";
import { fKeyTabInput } from "../../../Utility/Utilitys";

const ItemApproveDetailGrid = ({
  filePath,
  headObj,
  vMediaQuery,
  handleFileChange,
  fExport,
  fImport,
  detailGridData,
  setDetailGridData,
  handleChange,
  rejectionReason,
  docStatus,
  fileInputRef,
}) => {
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [brandOptions, setBrandOptions] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);
  const categoryRefs = useRef([]);
  const brandRefs = useRef([]);
  const vendorRefs = useRef([]);
  const docRefs = useRef([]);

  // Handle KeyUp to move focus on "Enter"
  const handleKeyUp = (e, index, nextRefArray) => {
    if (e.key === "Enter") {
      const nextInput = nextRefArray.current[index];
      if (nextInput) {
        nextInput.focus(); // Move focus to next input
      }
    }
  };

  const handleNarrChange = (index, event) => {
    const updatedDetailGridData = [...detailGridData];
    updatedDetailGridData[index][event.target.name] = event.target.value;
    setDetailGridData(updatedDetailGridData);
  };

  const handleRejectionReasonChange = (index, newValue) => {
    setDetailGridData((prevDetailGridData) => {
      const updatedGridData = [...prevDetailGridData];
      updatedGridData[index] = {
        ...updatedGridData[index],
        rejectReason: newValue, // Update RejectionReason
        B_Rejection_reason: newValue.map((item) => item.UId).join(","), // Update B_Rejection_reason
        B_Rejection_reasonName: newValue.map((item) => item.Name1).join(", "), // Update B_Rejection_reasonName
      };
      return updatedGridData;
    });
  };

  const fItemCategoryData = async () => {
    const payload = { anyDate: "%a%", type: "category" };
    const response = await ItemRequestFieldSearchAPI(payload);

    if (response.status === 200) {
      setCategoryOptions(response?.data?.ResultSet || []);
    }
  };
  const fItemBrandData = async () => {
    const payload = { anyDate: "%a%", type: "brand" };
    const response = await ItemRequestFieldSearchAPI(payload);

    if (response.status === 200) {
      setBrandOptions(response?.data?.ResultSet || []);
    }
  };
  const fItemVendorData = async () => {
    const payload = { anyDate: "%a%", type: "vendor" };
    const response = await ItemRequestFieldSearchAPI(payload);

    if (response.status === 200) {
      setVendorOptions(response?.data?.ResultSet || []);
    }
  };

  const handleCategoryChange = (index, newValue) => {
    const updatedDetailGridData = [...detailGridData];

    if (!newValue || newValue === "") {
      // Reset related fields if CategoryName is empty
      updatedDetailGridData[index].CategoryName = "";
      updatedDetailGridData[index].B_Category = "";
      updatedDetailGridData[index].B_SubCategory = "";
      updatedDetailGridData[index].SubCategoryName = "";
      updatedDetailGridData[index].B_MainCategory = "";
      updatedDetailGridData[index].MainCategoryName = "";
    } else {
      // Update fields based on the selected category
      const selectedCategory = categoryOptions?.find(
        (opt) => opt.Name === newValue
      );
      updatedDetailGridData[index].CategoryName = selectedCategory?.Name || "";
      updatedDetailGridData[index].B_Category = selectedCategory?.Code || "";
      updatedDetailGridData[index].B_SubCategory =
        selectedCategory?.SubCategory || "";
      updatedDetailGridData[index].SubCategoryName =
        selectedCategory?.SubCategoryName || "";
      updatedDetailGridData[index].B_MainCategory =
        selectedCategory?.MainGroupCode || "";
      updatedDetailGridData[index].MainCategoryName =
        selectedCategory?.MainGroupName || "";
    }

    setDetailGridData(updatedDetailGridData);
  };

  const handleBrandChange = (index, newValue) => {
    const updatedDetailGridData = [...detailGridData];

    if (!newValue || newValue === "") {
      // Reset related fields if CategoryName is empty
      updatedDetailGridData[index].B_Brand = "";
      updatedDetailGridData[index].BrandName = "";
    } else {
      // Update fields based on the selected category
      const selectedCategory = brandOptions?.find(
        (opt) => opt.Name === newValue
      );
      updatedDetailGridData[index].BrandName = selectedCategory?.Name || "";
      updatedDetailGridData[index].B_Brand = selectedCategory?.Code || "";
    }

    setDetailGridData(updatedDetailGridData);
  };

  const handleVendorChange = (index, newValue) => {
    const updatedDetailGridData = [...detailGridData];

    if (!newValue || newValue === "") {
      // Reset related fields if CategoryName is empty
      updatedDetailGridData[index].B_Vendor = "";
      updatedDetailGridData[index].VendorName = "";
    } else {
      // Update fields based on the selected category
      const selectedCategory = vendorOptions?.find(
        (opt) => opt.Name === newValue
      );
      updatedDetailGridData[index].VendorName = selectedCategory?.Name || "";
      updatedDetailGridData[index].B_Vendor = selectedCategory?.Code || "";
    }

    setDetailGridData(updatedDetailGridData);
  };

  useEffect(() => {
    fItemCategoryData();
    fItemBrandData();
    fItemVendorData();
  }, []);

  return (
    <>
      <Box>
        <Grid container justifyContent={"end"} alignItems={"center"}>
          <Grid xs={8} sm={4} md={3} textAlign={"end"}>
            <TextField
              size="small"
              sx={{ mr: 2 }}
              variant="outlined"
              placeholder="Excel upload"
              value={filePath}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <Button
                      variant="contained"
                      size="small"
                      component="label"
                      sx={{
                        textTransform: "capitalize",
                        fontWeight: 500,
                        fontSize: vMediaQuery
                          ? "11px !important"
                          : "13px !important",
                        padding: vMediaQuery
                          ? "0px 0px !important"
                          : "0px 8px !important",
                      }}
                      disabled={headObj?.A_Status != "ENTER"}
                    >
                      Choose File
                      <input
                        ref={fileInputRef}
                        type="file"
                        accept=".xlsx, .xls"
                        hidden
                        onChange={handleFileChange}
                      />
                    </Button>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={2} sm={0.8} md={0.6}>
            <Box className="importBox">
              <IconButton
                onClick={fImport}
                disabled={headObj?.A_Status != "ENTER"}
              >
                <FileUploadOutlinedIcon />
              </IconButton>
              <Typography variant="caption" sx={{ mt: -1, color: "#579bfc" }}>
                Import
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={2} sm={0.8} md={0.6}>
            <Box className="exportBox">
              <IconButton onClick={fExport}>
                <FileDownloadOutlinedIcon />
              </IconButton>
              <Typography variant="caption" sx={{ mt: -1 }}>
                Export
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <TableContainer
        component={Paper}
        className="table"
        sx={{
          height: "50vh !important",
          width: "100%",
        }}
      >
        <Table
          size="medium"
          sx={{
            "& .MuiTableCell-root": {
              borderRight: "1px solid #d0d4e4 !important",
              textAlign: "left",
            },
          }}
          stickyHeader
        >
          <TableHead>
            <TableRow className="table-head">
              <TableCell sx={{ display: "none" }}>ID</TableCell>
              <TableCell sx={{ width: "6%" }}>Barcode</TableCell>
              <TableCell sx={{ width: "12%" }}>Item Name</TableCell>
              <TableCell sx={{ width: "12%" }}>Arabic Name</TableCell>
              <TableCell sx={{ display: "none" }}>Category Code</TableCell>
              <TableCell sx={{ width: "6%" }}>Category</TableCell>
              <TableCell sx={{ display: "none" }}>Sub Category Code</TableCell>
              <TableCell sx={{ width: "6%" }}>SubCategory</TableCell>
              <TableCell sx={{ display: "none" }}>Main Category Code</TableCell>
              <TableCell sx={{ width: "6%" }}>MainCategory</TableCell>
              <TableCell sx={{ display: "none" }}>Brand Code</TableCell>
              <TableCell sx={{ width: "5%" }}>Brand</TableCell>
              <TableCell sx={{ display: "none" }}>Vendor code</TableCell>
              <TableCell sx={{ width: "8%" }}>Vendor</TableCell>
              <TableCell
                sx={{
                  textAlign: "left  !important",
                  width: "3%",
                }}
              >
                Packing
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left  !important",
                  width: "3%",
                }}
              >
                CostPr
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left  !important",
                  width: "3%",
                }}
              >
                RSP
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left  !important",
                  width: "5%",
                }}
              >
                ArticleNo
              </TableCell>
              <TableCell sx={{ width: "3%" }}>Document</TableCell>
              <TableCell sx={{ width: "6%" }}>Narration</TableCell>
              <TableCell sx={{ width: "15%" }}>Rejection Reason</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {detailGridData?.map((row, index) => (
              <TableRow
                key={index}
                className="table-body"
                sx={{
                  backgroundColor:
                    row.B_Line_Status === "ACCEPT"
                      ? "#b1f6b217 !important"
                      : row.B_Line_Status === "MODIFY"
                      ? "#ffffa721 !important"
                      : row.B_Line_Status === "REJECT"
                      ? "#ff000008 !important"
                      : "inherit",
                }}
              >
                <TableCell sx={{ display: "none" }}>{row.B_Id}</TableCell>
                <TableCell s>{row.B_Barcode}</TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    sx={{
                      "& .MuiInputBase-root": {
                        padding: "0px 2px !important",
                      },
                      "& .MuiOutlinedInput-input": {
                        fontSize: "10px",
                        padding: "6px 2px !important",
                      },
                    }}
                    name="B_ItemName"
                    autoComplete="off"
                    id="ApproveItemName"
                    value={row.B_ItemName}
                    onKeyUp={(e) => {
                      fKeyTabInput(e, "B_ItemNameFL");
                    }}
                    onChange={(e) => handleChange(index, e)}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    sx={{
                      "& .MuiInputBase-root": {
                        padding: "0px 2px !important",
                      },
                      "& .MuiOutlinedInput-input": {
                        fontSize: "11px",
                        padding: "6px 2px !important",
                      },
                    }}
                    name="B_ItemNameFL"
                    id="B_ItemNameFL"
                    autoComplete="off"
                    value={row.B_ItemNameFL}
                    onKeyUp={(e) => handleKeyUp(e, index, categoryRefs)}
                    onChange={(e) => handleChange(index, e)}
                  />
                </TableCell>
                <TableCell sx={{ display: "none" }}>
                  {row.CategoryCode}
                </TableCell>
                <TableCell>
                  {/* {row.CategoryName} */}
                  <Autocomplete
                    freeSolo
                    id={`category-${index}`}
                    disableClearable
                    value={row.CategoryName || ""}
                    onChange={(event, newValue) =>
                      handleCategoryChange(index, newValue)
                    }
                    autoComplete="off"
                    options={categoryOptions?.map((opt) => opt.Name)}
                    renderInput={(params) => (
                      <TextField
                        id="AppCatName"
                        sx={{
                          "& .MuiInputBase-root": {
                            padding: "0px 2px !important",
                          },
                          "& .MuiOutlinedInput-input": {
                            fontSize: "10px",
                            padding: "6px 2px !important",
                          },
                        }}
                        {...params}
                        inputRef={(el) => (categoryRefs.current[index] = el)}
                        onKeyUp={(e) => handleKeyUp(e, index, brandRefs)}
                        slotProps={{
                          input: {
                            ...params.InputProps,
                            type: "search",
                          },
                        }}
                      />
                    )}
                  />
                </TableCell>
                <TableCell sx={{ display: "none" }}></TableCell>
                <TableCell>
                  {/* {row.SubCategoryName} */}
                  <TextField
                    fullWidth
                    sx={{
                      "& .MuiInputBase-root": {
                        padding: "0px 2px !important",
                      },
                      "& .MuiOutlinedInput-input": {
                        fontSize: "10px",
                        padding: "6px 2px !important",
                      },
                      "& .Mui-disabled": {
                        backgroundColor: "#80808008 !important", // Set text color to gray when disabled
                      },
                    }}
                    name="SubCategoryName"
                    id="SubCategoryName"
                    autoComplete="off"
                    value={row.SubCategoryName}
                    disabled={true}
                    // onKeyUp={(e) => handleKeyUp(e, index, categoryRefs)}
                    onChange={(e) => handleChange(index, e)}
                  />
                </TableCell>
                <TableCell sx={{ display: "none" }}>
                  {row.B_MainCategory}
                </TableCell>
                <TableCell>
                  {/* {row.MainCategoryName} */}
                  <TextField
                    fullWidth
                    sx={{
                      "& .MuiInputBase-root": {
                        padding: "0px 2px !important",
                      },
                      "& .MuiOutlinedInput-input": {
                        fontSize: "10px",
                        padding: "6px 2px !important",
                      },
                      "& .Mui-disabled": {
                        backgroundColor: "#80808008 !important", // Set text color to gray when disabled
                      },
                    }}
                    name="MainCategoryName"
                    id="MainCategoryName"
                    autoComplete="off"
                    value={row.MainCategoryName}
                    disabled={true}
                    //  onKeyUp={(e) => handleKeyUp(e, index, categoryRefs)}
                    onChange={(e) => handleChange(index, e)}
                  />
                </TableCell>
                <TableCell sx={{ display: "none" }}>{row.B_Brand}</TableCell>
                <TableCell>
                  {/* {row.BrandName} */}
                  <Autocomplete
                    freeSolo
                    id={`brand-${index}`}
                    disableClearable
                    options={brandOptions?.map((opt) => opt.Name)}
                    value={row.BrandName || ""}
                    onChange={(event, newValue) =>
                      handleBrandChange(index, newValue)
                    }
                    autoComplete="off"
                    renderInput={(params) => (
                      <TextField
                        id="ApproveBrandName"
                        sx={{
                          "& .MuiInputBase-root": {
                            padding: "0px 2px !important",
                          },
                          "& .MuiOutlinedInput-input": {
                            fontSize: "10px",
                            padding: "6px 2px !important",
                          },
                        }}
                        {...params}
                        inputRef={(el) => (brandRefs.current[index] = el)}
                        onKeyUp={(e) => handleKeyUp(e, index, vendorRefs)}
                        slotProps={{
                          input: {
                            ...params.InputProps,
                            type: "search",
                          },
                        }}
                      />
                    )}
                  />
                </TableCell>
                <TableCell sx={{ display: "none" }}>{row.B_Vendor}</TableCell>
                <TableCell>
                  <Autocomplete
                    freeSolo
                    id={`vendor-${index}`}
                    disableClearable
                    options={vendorOptions?.map((opt) => opt.Name)}
                    value={row.VendorName || ""}
                    onChange={(event, newValue) =>
                      handleVendorChange(index, newValue)
                    }
                    autoComplete="off"
                    renderInput={(params) => (
                      <TextField
                        id="VendorName"
                        sx={{
                          "& .MuiInputBase-root": {
                            padding: "0px 2px !important",
                          },
                          "& .MuiOutlinedInput-input": {
                            fontSize: "10px",
                            padding: "6px 2px !important",
                          },
                        }}
                        {...params}
                        inputRef={(el) => (vendorRefs.current[index] = el)}
                        onKeyUp={(e) => {
                          fKeyTabInput(e, "B_Packing");
                        }}
                        slotProps={{
                          input: {
                            ...params.InputProps,
                            type: "search",
                          },
                        }}
                      />
                    )}
                  />
                </TableCell>
                <TableCell>
                  {/* {row.B_Packing} */}
                  <TextField
                    sx={{
                      "& .MuiInputBase-root": {
                        padding: "0px 2px !important",
                      },
                      "& .MuiOutlinedInput-input": {
                        fontSize: "10px",
                        padding: "6px 2px !important",
                        textAlign: "left  !important",
                      },
                    }}
                    fullWidth
                    name="B_Packing"
                    id="B_Packing"
                    value={row.B_Packing}
                    autoComplete="off"
                    onKeyUp={(e) => {
                      fKeyTabInput(e, "B_CostPr");
                    }}
                    onChange={(e) => handleChange(index, e)}
                  />
                </TableCell>
                <TableCell>
                  {/* {row.B_CostPr} */}
                  <TextField
                    sx={{
                      "& .MuiInputBase-root": {
                        padding: "0px 2px !important",
                      },
                      "& .MuiOutlinedInput-input": {
                        fontSize: "10px",
                        padding: "6px 2px !important",
                        textAlign: "right  !important",
                      },
                    }}
                    fullWidth
                    autoComplete="off"
                    name="B_CostPr"
                    id="B_CostPr"
                    value={row.B_CostPr}
                    onKeyUp={(e) => {
                      fKeyTabInput(e, "B_RSP");
                    }}
                    onChange={(e) => handleChange(index, e)}
                  />
                </TableCell>
                <TableCell
                  className="ItemRequest-headInfo"
                  sx={{
                    "& .MuiInputBase-root": {
                      padding: "0px 2px !important",
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "6px 2px !important",
                      fontSize: "10px",
                      textAlign: "right  !important",
                    },
                  }}
                >
                  <TextField
                    fullWidth
                    name="B_RSP"
                    id="B_RSP"
                    value={row.B_RSP}
                    onKeyUp={(e) => {
                      fKeyTabInput(e, "SKU");
                    }}
                    onChange={(e) => handleChange(index, e)}
                  />
                </TableCell>
                <TableCell className="ItemRequest-headInfo">
                  <TextField
                    fullWidth
                    sx={{
                      "& .MuiInputBase-root": {
                        padding: "0px 2px !important",
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "6px 2px !important",
                        fontSize: "10px",
                        textAlign: "right  !important",
                      },
                    }}
                    autoComplete="off"
                    name="SKU"
                    id="SKU"
                    type="number"
                    value={row.SKU}
                    onChange={(e) => handleChange(index, e)}
                    onKeyUp={(e) => handleKeyUp(e, index, docRefs)}
                  />
                </TableCell>
                <TableCell
                  sx={{
                    "& .MuiInputBase-root": {
                      padding: "0px 2px !important",
                    },
                    "& .MuiSvgIcon-root": {
                      right: "2px !important",
                    },
                    "& .MuiOutlinedInput-input": {
                      fontSize: "10px",
                      padding: "6px 2px !important",
                    },
                  }}
                >
                  <FormControl fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="docStatus"
                      value={row.B_Line_Status || "ACCEPT"}
                      name="B_Line_Status"
                      onChange={(e) => handleChange(index, e)}
                      inputRef={(el) => (docRefs.current[index] = el)}
                      onKeyUp={(e) => {
                        fKeyTabInput(e, "B_Narration");
                      }}
                    >
                      {docStatus?.map((typ) => (
                        <MenuItem key={typ} value={typ}>
                          {typ}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    sx={{
                      "& .MuiInputBase-root": {
                        padding: "0px 2px !important",
                      },
                      "& .MuiOutlinedInput-input": {
                        fontSize: "10px",
                        padding: "6px 2px !important",
                      },
                    }}
                    name="B_Narration"
                    id="B_Narration"
                    autoComplete="off"
                    value={row.B_Narration}
                    onChange={(e) => handleNarrChange(index, e)}
                    onKeyUp={(e) => {
                      fKeyTabInput(e, "rejection-reason");
                    }}
                  />
                </TableCell>
                <TableCell
                  sx={{
                    "& .MuiInputBase-root": {
                      padding: "0px 2px !important",
                    },
                    "& .MuiAutocomplete-endAdornment": {
                      right: "2px !important",
                      top: "revert-layer",
                    },
                    "& .MuiOutlinedInput-input": {
                      fontSize: "10px",
                      padding: "6px 2px !important",
                    },
                  }}
                >
                  <Autocomplete
                    multiple
                    autoComplete="off"
                    id={`rejection-reason-${index}`}
                    options={rejectionReason}
                    getOptionLabel={(option) => option.Name1}
                    value={row.rejectReason || []}
                    isOptionEqualToValue={(option, value) =>
                      option.UId === value.UId
                    }
                    onChange={(event, newValue) =>
                      handleRejectionReasonChange(index, newValue)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        //  sx={{ width: yMediaQuery ? 150 : 250 }}
                      />
                    )}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ItemApproveDetailGrid;
